import {updateAdditionalData, updateUserInterests, updatedUserInfo}  from "../scripts/article/additionaldata-script";

Voonto.getInstance().define(['module'], function (module) {

    var baseurl = '/ajax/v2/api/v1/';
    const app = Voonto.getInstance();
    const vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
    if (vocUserNotificationsPath !== undefined) {
        baseurl = vocUserNotificationsPath + baseurl;
    }

    function additionaldata($elm) {
        var btn = $elm.data('btn');
        switch(btn) {
            case 'showadditionaldata':
                $elm.on('click', handleShowAddDataClick);
                break;
            case 'closepopupinfo':
                $elm.on('click', handleClosePopupInfoClick);
                break;
            case 'updateadditionaldata':
                $elm.on('click', handleUpdateAddDataClick);
                break;
            case 'closepopupdata':
                $elm.on('click', handleClosePopupDataClick);
                break;
            case 'updateinterests':
                $elm.on('click', handleUpdateInterestsClick);
                break;
            case 'closepopupinterests':
                $elm.on('click', handleClosePopupInterestsClick);
                break;
            case 'closepopup':
                $elm.on('click', handleClosePopup);
                break;
            case 'changedata':
                $elm.on('change', handleChangeData);
                break;
        }

    }

    function handleShowAddDataClick(ev){
        var currentContainer = Voonto.$('.popup_additional_data').find('.current_popup');
        var nextContainer = Voonto.$('.popup_additional_data').find('.next_popup');
        nextContainer.show();
        nextContainer.addClass('current_popup');
        nextContainer.removeClass('next_popup');
        if (nextContainer.hasClass('popup_user_data')){
            nextContainer.find('.next_field').show();
        }
        var oldnextcontainer= currentContainer;
        var currentContainer= nextContainer;
        oldnextcontainer.hide();
        oldnextcontainer.removeClass('current_popup');
        currentContainer.addClass('current_popup');
        currentContainer.show();
    }

    function handleClosePopupInfoClick(ev){
        var currentContainer = Voonto.$('.popup_additional_data').find('.current_popup');
        currentContainer.hide();
        currentContainer.removeClass('current_popup');
        Voonto.$('.popup_result p.p1').text('');
        Voonto.$('.popup_result p.p2').text('');
        Voonto.$('.popup_result p.p2').hide();
        Voonto.$('.popup_additional_data').hide();
    }

    function handleUpdateAddDataClick(ev){
       ev.preventDefault();
       updateAdditionalData(baseurl);
    }

    function handleClosePopupDataClick(ev){
        var currentContainer = Voonto.$('.popup_user_data');
        currentContainer.hide();
        currentContainer.removeClass('current_popup');
        Voonto.$('.popup_result').addClass('current_popup');
        Voonto.$('.popup_result p.p1').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
        Voonto.$('.popup_result p.p2').text('');
        Voonto.$('.popup_result p.p2').hide();
        Voonto.$('.popup_result').show();
    }

    function handleUpdateInterestsClick(ev){
        ev.preventDefault();
        updateUserInterests(baseurl);
    }

    function handleClosePopupInterestsClick(ev){
        var currentContainer = Voonto.$('.popup_user_interests');
        currentContainer.hide();
        currentContainer.removeClass('current_popup');
        Voonto.$('.popup_result').addClass('current_popup');
        var upUserInfo = updatedUserInfo();
        if (upUserInfo){
            $('.popup_result p.p1').html('<strong>¡Perfil actualizado con éxito!</strong>');
            $('.popup_result p.p2').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
            $('.popup_result p.p2').show();
        }else{
            $('.popup_result p.p1').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
            $('.popup_result p.p2').text('');
            $('.popup_result p.p2').hide();
        }
        Voonto.$('.popup_result').show();
    }

    function handleClosePopup(ev){
        var currentContainer = Voonto.$('.popup_additional_data').find('.current_popup');
        currentContainer.hide();
        currentContainer.removeClass('current_popup');
        Voonto.$('.popup_additional_data').hide();
    }

    function handleChangeData(ev){
        let flag = false;
        let buttonDisabled = Voonto.$('.popup_user_data .boton.desactivado.esquinas');
        let buttonActive = Voonto.$('.popup_user_data .boton.fondo-azul.esquinas');
        Voonto.$('.popup_additional_data .popup_user_data').find('select').each(function () {
          if(Voonto.$(this).val() != ''){
              flag = true;
              return false;
          }
        });
        if(flag === false) {
            buttonDisabled.show();
            buttonActive.hide();
        }else{
            buttonDisabled.hide();
            buttonActive.show();
        }
    }

    return {
        wakeUp($elm){
            Logger.info(`wake up module ${module.id}`);
            const app = Voonto.getInstance();

            var additionaldataUrl = app.lookup('vocento.config.nibara').additionaldataUrl;
            if (additionaldataUrl !== undefined) {
                baseurl = additionaldataUrl + '/';
            }

            app.when('vocuser:ready').then((gigyaUX) => {
                var userType = gigyaUX.getUserType();

                if (userType !== 'anonimo') {
                    additionaldata($elm);
                }
            });
        }
    }
});


// WEBPACK FOOTER //
// ./src/modules/additionaldata-module.js